<hbox class="buttons">
  <AppBarM>
    <!-- left -->
    <hbox class="empty" />

    <!-- left middle -->
    <hbox class="empty" />

    <AppMenuButton />

    <!-- right middle -->
    <hbox class="empty" />

    <!-- right -->
    <hbox class="empty" />
  </AppBarM>
</hbox>

<script lang="ts">
  import AppBarM from "../AppsBar/AppBarM.svelte";
  import AppMenuButton from "../AppsBar/AppMenuM/AppMenuButton.svelte";
</script>
